import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
// import axios from 'axios'
import i18n from './i18n'
import store from './store'
import router from './router'
import feathersClient from './feathers-client'
import '@fortawesome/fontawesome-free/css/all.css'
import './vuetify'
import './filters'
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)

Vue.config.productionTip = false
// axios.defaults.baseURL = process.env.VUE_APP_API || '/api'
// Vue.prototype.$http = axios

feathersClient
  .authenticate()
  .then((res) => {
    store.commit('authSuccess', res)
  })
  .catch(() => {
    if (
      !(
        window.location.pathname.includes('/login') ||
        window.location.pathname.includes('/register') ||
        window.location.pathname.includes('/wachtwoord-opvragen')
      )
    )
      router.push({ name: 'login' })
  })
  .finally(() => {
    new Vue({
      render: (h) => h(App),
      router,
      store,
      i18n: i18n(),
    }).$mount('#app')
  })
